import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "@fluentui/react";
import { toggleSelfEditPanel } from "../../../config/redux/client/clientActions";
import { panelS } from "../../../features/common/styles/panelStyles";
import SelfEditForm from "../forms/SelfEditForm";



const SelfEditPanel: React.FC = () => {
  const dispatch = useDispatch();
  const { selfEditPanelOpen } = useSelector(
    (state: RootStateOrAny) => state.client
  );

  const dismissPanel = () => {
    dispatch(toggleSelfEditPanel(false));
  };

  return (
    <Panel
      isOpen={selfEditPanelOpen}
      closeButtonAriaLabel="Close"
      headerText="Profil"
      onDismiss={dismissPanel}
      type={1}
      styles={panelS}
      isHiddenOnDismiss={false}
    >
     <SelfEditForm />
    </Panel>
  );
};

export default SelfEditPanel;